import { Component, Inject, OnInit } from '@angular/core';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { ModalNewCategory, ModalUpdateCategory } from '../../config-setup-inductionand-sections';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
export interface DialogData {
  edit: boolean,
  typeID:number,
  Name: string,
  Description: string,
  ExpiryMonths: number | null,
  Active:boolean
}

@Component({
  selector: 'app-add-induction-types',
  templateUrl: './add-induction-types.component.html',
  styleUrls: ['./add-induction-types.component.css']
})

export class AddInductionTypesComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AddInductionTypesComponent>,
    public _toaster: NotificationsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }

  Name: string = "";
  Description: string = "";
  ExpiryMonths: number | null = null;;
  selectedStatus:number=1;
  Active:boolean;
  ngOnInit() {

    if (this.data) {

      this.Name = this.data.Name;
      this.Description = this.data.Description;
      this.ExpiryMonths = this.data.ExpiryMonths
      this.Active = this.data.Active

      this.selectedStatus = this.Active==true?1:0;

      console.log("data__",this.data,this.selectedStatus)

    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    if(this.data.typeID  != undefined){
      let params = new ModalUpdateCategory();
      params.typeID = this.data.typeID;
      params.ExpiryMonths = this.ExpiryMonths;
      params.InductionTypeName = this.Name;
      params.TypeDesc = this.Description;
      params.active=this.selectedStatus==1?true:false;
      //create new category
      this._inductionService.UpdateCategory(params).subscribe(res => {
        console.log("UpdateCategory", res)
        if (res.m_Item1) {
          this._toaster.success('Updated successfully.');
          this.dialogRef.close(true);
        }
        // this.dialogRef.close();
  
      })
      
    }else{
      let params = new ModalNewCategory();
      params.ExpiryMonths = this.ExpiryMonths;
      params.InductionTypeName = this.Name;
      params.TypeDesc = this.Description;
      params.active=this.selectedStatus==1?true:false;
      //create new category
      this._inductionService.CreateNewCategory(params).subscribe(res => {
        console.log("CreateNewCategory", res)
        if (res.m_Item1) {
          this._toaster.success('Created successfully');
          this.dialogRef.close(true);

        }else{
          this._toaster.error('Failed to create');
        }
      })
    }
  }
}
